export class NewsDetail {
    public Id: string;
    public Name: string;
    public Suchkategorie: string;
    public Titel: string;
    public Vorschautext: string;
    public Tags: string;
    public CustomDate: string;
    public Url: string;
    public FullText_Suggest: string;

    constructor(item: any){
        this.Id = item.Id?? item.id ?? "";
        this.Name = item.Name?? item.name ?? "";
        this.Suchkategorie = item.Suchkategorie?? item.suchkategorie ?? "";
        this.Titel = item.Titel?? item.titel ?? "";
        this.Vorschautext = item.Vorschautext?? item.vorschautext ?? "";
        this.Tags = item.Tags?? item.tags ?? "";
        this.CustomDate = item.CustomDate?? item.customDate ?? "";
        this.Url = item.Url?? item.url ?? "";
        this.FullText_Suggest = item.FullText_Suggest?? item.fullText_Suggest ?? "";
    }
}

export class NewsSearchResult{
    public Results: NewsDetail[];
    public ResultTotalCount : number;

    constructor(item:any){        
        this.Results = [] as NewsDetail[];        
        this.ResultTotalCount = item.ResultTotalCount?? item.resultTotalCount ?? 0;

        const results = item.Results?? item.results ?? [] as any;
        results.forEach((element:any) => {
            this.Results.push(new NewsDetail(element))
        });
    }
}